const PhoneNumberUtil = require('google-libphonenumber').PhoneNumberUtil;
const services = require('@jutro/legacy/services');
const mlPortalsUtils = require('ml-portals-util-js');
const moment = require('moment');
const subtreeValidity = require('../../../../common/override/aspects/SubtreeValidity').default;

const MLLocalDateUtil = mlPortalsUtils.MLLocalDateUtil;
const MLModifierValidityFuncUtil = mlPortalsUtils.MLModifierValidityFuncUtil;
const localeService = services.ServiceManager.getService('locale-service');

// EXAMPLE: Adding a new Expression Language Type
// Declare a new Expression Language Type
// const exampleExpressionLanguageType = {
//     namespace: 'pc', // Optional namespace for Expression Type
//     type: {  // Required Expression Language Object which should contain function properties that correspond to your backend Expression Object
//         getValue(val) {
//             return val || 'default value';
//         }
//     }
// }

// EXAMPLE - Adding a new Validation function
// const exampleArrLength = (a) => {
//     return a ? a.length : 0;
// }

const dateFormatter = {
    type: { // Override OOTB date formatter formatShortDate method
        formatShortDate: (date) => {
            return date ? moment(date).format('MM/DD/YY') : '';
        },
        formatFourDigitsYearDateML: (date) => {
            return date ? moment(date).format('MM/DD/YYYY') : '';
        }
    }
}

const phoneUtilML = {
    type: {
        isPossibleNumber: (phoneNumber, countryCode) => {
            const phoneUtils = PhoneNumberUtil.getInstance();
            let returnVal = true;
            let extPos;
            let number;
            if (phoneNumber) {
                extPos = phoneNumber.indexOf(' x');
                number = extPos > 0 ? phoneNumber.substring(0, extPos) : phoneNumber;
                number = number.replace(/[-_]/g, '');
                try {
                    // MetLife currently using isPossibleNumber instead of OOTB isValidNumber
                    returnVal = phoneUtils.isPossibleNumber(phoneUtils.parse(number, countryCode));
                } catch (e) {
                    // Suppress log error message from libphonenumber when number is not valid
                    return false;
                }
            }
            return returnVal;
        }
    }
}

// Export Expression Types and Validation Functions
module.exports = {
    // aspectFactory override is an Elysian feature. It has been imported here to 
    // support ML backward compatibility to log subtree validation in brwoser console. 
    // Beware of that two platform packages have been modified to support this feature 
    // 1. gw-portals-viewmodel-js <-- Updated
    // 2. gw-portals-viewmodel-utils-js <-- NEW
    // The packages needs to roll back to OOTB when upgrading to Elysian in the future
    aspectFactory: {
        subtreeValiity: () => subtreeValidity
    },
    // Types
    // Key should match the backend package name for your Expression Object
    // Value should be your new Expression Language Type
    types: {
        "metlife.edge.capabilities.locale.util.DateFormatterML": dateFormatter,
        "metlife.edge.capabilities.locale.util.PhoneUtilML": phoneUtilML
    },
    // Validations
    // Function name should match backend validation function
    validations: {
        // exampleArrLength,
        // ML
        isCurrency: (obj) => {
            if (obj === undefined || obj === null || obj === '') {
                return false;
            }

            if (typeof obj === 'number') {
                // eslint-disable-next-line no-param-reassign
                obj = obj.toString();
            }

            if (typeof obj !== 'string') {
                return false;
            }

            if (!obj.match(/^-?\d*(.\d*)?$/)) {
                return false;
            }

            const currencyInfo = localeService
                ? localeService.getLocaleInfo().currency
                : { fractionSize: 2 };
            return obj.indexOf('.') === -1 || obj.indexOf('.') >= obj.length - (currencyInfo.fractionSize + 1);
        },
        isDateValidML: (isSubmitAgent, isPolicyChange, value) => {
            if (isPolicyChange) {
                return true;
            }
            const givenDate = MLLocalDateUtil.localDate2Date(value);
            const todayMoment = moment(new Date()).startOf('day');
            const givenMoment = moment(givenDate);
            let ret;
            if (isSubmitAgent) {
                ret = givenMoment.diff(todayMoment, 'days') <= 90;
            } else {
                ret = givenMoment.diff(todayMoment, 'days') > 0 && givenMoment.diff(todayMoment, 'days') <= 90;
            }
            return ret;
        },
        checkFutureEffectiveDate: (effectiveDate, newEffectiveDate) => {
            if (!newEffectiveDate) {
                return true;
            }

            const formatEffectiveDate = moment(MLLocalDateUtil.localDate2Date(effectiveDate))
            const formatNewEffectiveDate = moment(MLLocalDateUtil.localDate2Date(newEffectiveDate))


            return formatEffectiveDate.isSameOrAfter(formatNewEffectiveDate)

        },
        getErrormessageForEmployeeDepartmentNumber(isAvailable, prePopulateError, defaultError, val, maxLength) {
            let error;

            if(isAvailable && val.length !== maxLength){
                error = prePopulateError
            } else {
                error = defaultError
            }

            return error
        },
        validateLowerAgeRangeML: (value, minimumAgeBound) => {
            const localDateDOB = MLLocalDateUtil.date2LocalDate(new Date());
            const minYear = localDateDOB.year - minimumAgeBound;
            const bornInALaterYear = value.year < minYear;
            const bornInALaterMonth = value.year === minYear && value.month < localDateDOB.month;
            const bornOnALaterOrCurrentDay = value.year === minYear && value.month === localDateDOB.month && value.day <= localDateDOB.day;

            return bornInALaterYear || bornInALaterMonth || bornOnALaterOrCurrentDay;
        },


        validateUpperAgeRangeML: (value, maximumAgeBound) => {
            const localDateDOB = MLLocalDateUtil.date2LocalDate(new Date());
            const minYear = localDateDOB.year - maximumAgeBound;
            const bornInPreviousYear = value.year > minYear;
            const bornInPreviousMonth = value.year === minYear && value.month > localDateDOB.month;
            const bornOnPreviousOrCurrentDay = value.year === minYear && value.month === localDateDOB.month && value.day > localDateDOB.day;

            return bornInPreviousYear || bornInPreviousMonth || bornOnPreviousOrCurrentDay;
        },


        getErrorMessageForAgentOrConsumerML: (isSubmitAgent, agent, consumer)=> {
            let ret;
            if (isSubmitAgent) {
                ret = agent;
            } else {
                ret = consumer;
            }
            return ret;
        },
        hasBlockingUWIssuesML: (uwIssues) => {
            return uwIssues && uwIssues.some((uwIssue) => uwIssue.currentBlockingPoint !== 'NonBlocking');
        },
        containsPatternsML: (pattern, value) => {
            return !pattern || !value || !!(new RegExp(pattern, 'i').exec(value));
        },
        compareDateStringWithDateML: (dateStr, dateStrFormat, anotherDate, anotherDateToFirstDayOfMonth = false) => {
            const date = moment(dateStr, dateStrFormat.toUpperCase());
            const anotherDateRef = anotherDateToFirstDayOfMonth ? moment(anotherDate).startOf('month') : anotherDate;
            if (date > anotherDateRef) {
                return 1;
            }
            return date === anotherDateRef ? 0 : -1;
        },
        isCarrierValidML: (value) => {
            return value && (value.code === 'metlife_propertycasualty_ml' || value.code === 'metlife_inc_ml');
        },
        intLengthML: (int) => {
            return int ? int.toString().length : 0;
        },
        isModifierValidML: (chosenTermValue, funcName, optionalParams, editMode) => {
            if (editMode) {
                let params = optionalParams;
                if (params) {
                    params = optionalParams.split(new RegExp(',\\s*'));
                }
                return MLModifierValidityFuncUtil.isModifierValid(chosenTermValue, funcName, params);
            }
            return true;
        },
        containsKeyML: (map, key) => {
            // eslint-disable-next-line no-prototype-builtins
            return map.hasOwnProperty(key);
        },
        isValidRoofUpdateYearML: (roofDate, yearBuilt, periodStartDate) => {
            if (roofDate && periodStartDate) {
                return roofDate.year >= yearBuilt && roofDate.year <= periodStartDate.year;
            }

            return true;
        },
        isLicenseNumberValidExt: (licenseNumber, licenseState) => {
            if (licenseState && licenseState.code === 'WY') {
                return !licenseNumber || new RegExp(`^${'[0-9]{9,9}|([0-9]{6,6}[//-][0-9]{3,3})'}$`).test(licenseNumber);
            }
            return !licenseNumber || new RegExp(`^${'[a-zA-Z0-9*]*'}$`).test(licenseNumber);
        },
        hasCategory: (value, parent) => {
            return !parent || value.belongsToCategory(parent);
        },
        belongsToFilter: (value, filterName)=> {
            return value.typelist.getFilter(filterName).allows(value);
        },
        typekeyIn: (tk, values)=> {
            return values.indexOf(tk.code) >= 0;
        }
    },
    validationMessagesToIgnore: [
        // validation messages that the view model surfaces that Jutro might duplicate

        // This field is required
        'displaykey.Edge.Web.Api.Model.NotNull',
        // Value entered must be a valid phone number
        'displaykey.Edge.Web.Api.Model.Phone'
    ]
}